import { useState, useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import Pagination from '@mui/material/Pagination';
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ColorRing } from 'react-loader-spinner'
import { ClearSession } from '../../Common/Common'


import { Cookies } from 'react-cookie';
const cookies = new Cookies();

const CustodianMasterTable = ({ loading, handleReset, currentPageNo, handleChange, filterData, filterList, setColoredRow, ColoredRow, setFilterData, handleEditData, tableData, getCustodianMasterData }) => {


    //const [type, setType] = useState('')
    //const [pageIndex, setPageIndex] = useState('')
    const [SessionClear, SetSessionClear] = useState(false);

    const handleDeleteData = (EventId) => {
        confirmAlert({
            message: 'Do you want to Delete this Record ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => handleDelete(EventId)
                },
                {
                    label: 'No',
                    onClick: () => setColoredRow(null)
                }
            ]
        });
    }

    const handleDelete = async (id) => {
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: await cookies.get('loginUserCode'),
            Source: 'web',
            CustodianMasterID: id
        }
        await fetch(`/api/MasterController/DeleteCustodianMaster`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            if (res.status === "SUCCESS") {
                toast.success(res.message, {
                   
                })
            }
            else if (res.message === "EXPIRED") {
                SetSessionClear(true);
                ClearSession();
            }
            else {
                toast.error(res.message, {
                  
                })
            }
            getCustodianMasterData();
            handleReset();
        }).catch((err) => {
            toast.error(err, {
              
            })
        })
    }
 
  
    const handleHighlight = (id) => {
        setColoredRow(id)
    }
    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(tableData.pageSize)))

    useEffect(() => {
        getCustodianMasterData()
    }, [])


    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading mt-2">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                                <div className="filter-section d-flex gap-2">
                                    <span className=" d-flex gap-1">
                                        <span className='select_records_filter'>
                                            <select className='filter-select'
                                                placeholder='Please select'
                                                value={filterData.SearchFieldValue}
                                                onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}>

                                                {filterList ? (filterList.map((item, index) => (
                                                    <option key={index} value={item.searchingValue}>{item.searchingText}</option>
                                                ))) : (<></>)}
                                            </select>
                                        </span>
                                        <span className='select_records_filter' >
                                            <select className='filter-select' value={filterData.StartValue} onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}>

                                                <option value="1">Exactly</option>
                                                <option value="2">Contains</option>
                                                <option value="3">Start With</option>
                                            </select>
                                        </span>
                                        <span className=' filter-search-bar d-flex gap-2 form-control'>
                                            <input
                                                name="query"
                                                value={filterData.SearchText}
                                                onChange={(e) => {
                                                    setFilterData({ ...filterData, SearchText: e.target.value });
                                                }}
                                                placeholder="Search"
                                                title="Enter search keyword"
                                            />
                                            <button type="submit" className='search-btn Filter-Search-Button-main' title="Search" onClick={() => {
                                                getCustodianMasterData();
                                                setFilterData({
                                                    ...filterData,
                                                })
                                            }}>
                                                <i className="bi bi-search" />
                                            </button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">
                                                {tableData?.length !== 0 ?
                                                    (
                                                        tableData?.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr >
                                                                    <th>{"Action"}</th>

                                                                    <th>{tableData.hEventName}</th>
                                                                    <th>{tableData.hCustodianCode}</th>
                                                                    <th>{tableData.hCustodianName}</th>
                                                                    <th>{tableData.hDistrict}</th>
                                                                    <th>{tableData.hIsActive}</th>
                                                                    <th>{tableData.hCreatedBy}</th>
                                                                    <th>{tableData.hCreatedDate}</th>
                                                                    <th>{tableData.hModifiedBy}</th>
                                                                    <th>{tableData.hModifiedDate}</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData?.getCustodianMasterData !== null ?
                                                                    (
                                                                        (tableData?.getCustodianMasterData)?.map((event, index) => (
                                                                            <tr key={index} onClick={() => handleHighlight(event.edit)} style={{ background: event.edit === ColoredRow ? '#cbe2ff' : '' }}  >
   
                                                                                <td >
                                                                                    <button title="Edit" className="btn btn-link text-success btn-sm" onClick={() => handleEditData(event.edit)}>
                                                                                        <i className="bi bi-pencil-square" />
                                                                                    </button>
                                                                                    <button title="Delete" className="btn btn-link text-danger btn-sm" onClick={() => handleDeleteData(event.del)}>
                                                                                        <i className="bi bi-trash3" />
                                                                                    </button>
                                                                                </td>

                                                                                <td>{event.eventCode}</td>
                                                                                <td>{event.custodianCode}</td>
                                                                                <td>{event.custodianName}</td>
                                                                                <td>{event.districtCode}</td>
                                                                                <td>{event.isActive}</td>
                                                                                <td>{event.createdBy}</td>
                                                                                <td>{event.createdDate}</td>
                                                                                <td>{event.modifiedBy}</td>
                                                                                <td>{event.modifiedDate}</td>

                                                                            </tr>
                                                                        ))
                                                                    ) : (<></>)}
                                                            </tbody>
                                                        </table>) : (<></>)

                                                    ) : (<></>)}
                                            </div>
                                            {countNo > 1 ?
                                                        <Pagination count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange} shape="rounded" />

                                                : ''}
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center'>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                                {SessionClear ? <ClearSession /> : <></>}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}
export default CustodianMasterTable;